var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._b({attrs:{"error-messages":_vm.mensajeError},on:{"change":_vm.procesarImagen},model:{value:(_vm.fichero),callback:function ($$v) {_vm.fichero=$$v},expression:"fichero"}},'v-file-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }